import React, { Component } from "react";
import quickSightAxiosCall from '../../components/axiosComponent/quickSightAxiosCall'
import CLIENT_QUICKSIGHT_URL from '../../config/config'

const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

class QuicksightDashboard extends Component {

  state = {
    callonece: 0,
    dashboardEmbed: [],
    noLoader: false,
    dashboardRef: React.createRef()
  }

  componentDidMount() {
    this.getQuickSightUrl();
  }

  getQuickSightUrl = () => {
    let dashboardURL = CLIENT_QUICKSIGHT_URL.BASE_QUICKSIGHT_DASHBOARD;
    if (this.state.callonece <= 1) {

      quickSightAxiosCall({
        url: "/aws/dashboard",
        method: "post",
        Items: { dashboard_id: dashboardURL }
      })//CommonGetApi({ url: 'branch' })
        .then((response) => {
          this.setState({ callonece: 2 });
          this.embedDashboard(response.data.data)
        }).catch(
          (error) => {
            if (error?.data?.data) {
              this.embedDashboard(error.data.data)
            }
          })
    }
  }

  embedDashboard = (url) => {
    console.log(url)
    //var containerDiv = document.getElementById("embeddingContainer");

    var options = {
      url: url,
      container: this.state.dashboardRef.current,
      scrolling: "no",
      height: "900px",
      width: "100%",
      footerPaddingEnabled: true,
      printEnabled: true,
    };
    let dashboard = QuickSightEmbedding.embedDashboard(options);
    this.setState({ dashboardEmbed: dashboard }, () => { this.setState({ noLoader: true }) })
  }

  render() {
    return (
      <>
        <div ref={this.state.dashboardRef} id="embeddingContainer"></div>
        {this.state.noLoader ?
          null :
          <>
            <div className="spinner-loader-quicksight">

              <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-secondary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-success" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-danger" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-warning" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-info" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-light" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-dark" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </>
        }
      </>
    );
  }
}

export default QuicksightDashboard;
